
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import App_header from "../../../component/app_header/app_header";
import App_header_title_simple from "../../../component/app_header_title/app_header_title_simple";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./quotation_form.css";
import AppSteps from "../../../component/app_steps/app_steps2";
import AppTextField from "../../../component/app_text_field/app_text_field";
import UtilBloc from "../../../../bloc/util_bloc";
import AppModal from "../../../component/app_modal/app_modal";
import QuotationBloc from "../../../../bloc/quotation_bloc";
import AppBottomBar from "../../../component/app_bottom_bar/app_bottom_bar";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import { ReactComponent as InfoIcon } from "../../../../Info2.svg";
import Tooltip from "antd/lib/tooltip";

const StepData = [
    {
        title: 'Personal Details',
        status: 'process'
    },
    {
        title: 'Financing Details',
        status: 'process'
    },
    {
        title: 'Takaful Details'
    },
    {
        title: 'Review and Submit'
    },
]

class TakafulDetailsForm extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            section: this.props.match.params.section,
            keyword: null,
            coverageTerm: null,
            initialSumCovered: null,
            contributionAmount: null,
            contributionMode: 'Cash',
            criticalIllnessProtectionAmount: null,
            isSaveModalOpen: false,
            isDiscardModalOpen: false,
            errorCoverageTermInd: false,
            errorInitialSumCoveredInd: false,
            errorContributionAmount: false,
            errorCriticalIllnessProtectionAmountInd: false,
            errorMessage: 'Fill in the required field.',
        };
    }


    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    getBackToFinancingDetails = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_financial_details}/${this.getQuotationId()}`
    }

    getBackToQuotationDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }

        this.getFormData();
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    async getFormData() {
        this.setState({ loading: true });
        let calculationData = await QuotationBloc.getCalculatedContributionAmount(this.getQuotationId());
        let formData = await QuotationBloc.getFormDetailQuotation(this.getQuotationId(), Config.quotation.formLabelMapping.takafulDetails.label);
        let editable = await QuotationBloc.editGeneratedQuotation(this.getQuotationId());
        if (editable.success) {
            this.setState({
                loading: false,
                formData: calculationData,
                coverageTerm: calculationData.data.coverageTerm,
                initialSumCovered: calculationData.data.initialSumCovered,
                contributionAmount: calculationData.data.totalSingleContribution,
                criticalIllnessProtectionAmount: calculationData.data.criticalIllnessSumCovered,
            })
        } else {
            this.setState({
                loading: false,
                editErrorModal: true,
                message: 'This quotation cannot be edit or update.'
            })
        }

    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    handleInitialSumCovered = (val) => {
        this.setState({ initialSumCovered: val });
    }

    handleContributionAmount = (val) => {
        this.setState({ contributionAmount: val });
    }

    handleCoverageTerm = (val) => {
        this.setState({ coverageTerm: val });
    }

    handleCriticalIllnessProtectionAmount = (val) => {
        this.setState({ criticalIllnessProtectionAmount: val });
    }

    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true })
    }
    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false })
    }

    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true })
    }
    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false })
    }

    handleStopWithoutSaving = () => {
        this.getBackToQuotationDashboard()
    }

    handleValidateForm = () => {
        const { initialSumCovered, contributionAmount, coverageTerm, criticalIllnessProtectionAmount } = this.state

        this.setState({
            errorInitialSumCoveredInd: UtilBloc.isNullOrEmpty(initialSumCovered) ? true : false,
            errorContributionAmount: UtilBloc.isNullOrEmpty(contributionAmount) ? true : false,
            errorCoverageTermInd: UtilBloc.isNullOrEmpty(coverageTerm) ? true : false,
            errorCriticalIllnessProtectionAmountInd: UtilBloc.isNullOrEmpty(criticalIllnessProtectionAmount) ? true : false,
        })

        if (
            !UtilBloc.isNullOrEmpty(initialSumCovered) && !UtilBloc.isNullOrEmpty(contributionAmount)
            && !UtilBloc.isNullOrEmpty(coverageTerm) && !UtilBloc.isNullOrEmpty(criticalIllnessProtectionAmount)
        ) {
            return true;
        } else {
            return false;
        }
    }

    handleSaveCurrentStep = () => {
        this.handleFormSubmit('save');
    }

    handleNextStep = () => {
        const isValidate = this.handleValidateForm();
        if (isValidate) {
            this.handleFormSubmit('next');
        }


    }

    async handleFormSubmit(type) {
        this.setState({ loading: true });
        let data = Config.quotation.formDataMapping.takafulDetails;
        data.coverageTerm = this.state.coverageTerm || ''
        data.initialSumCovered = this.state.initialSumCovered || ''
        data.totalSingleContribution = this.state.contributionAmount || ''
        data.criticalIllnessSumCovered = this.state.criticalIllnessProtectionAmount || ''

        let response = await QuotationBloc.saveForm(this.getQuotationId(), 'TAKAFUL_DETAILS', data);
        if (response.success) {

            if (type == 'next') {
                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_review_submit}/${this.getQuotationId()}`
            } else {
                this.getBackToQuotationDashboard();
            }
        } else {
            this.setState({
                loading: false,
                errorModal: true,
                title: 'Error',
                message: response.message
            })
        }
    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={true}
                lableDiscard={'Discard'}
                lableSaveAndClose={'Save & Close'}
                lableNext={'Next'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleNextStep() }}
                onDiscard={(e) => this.handleDiscardModalOpen()}
                onSaveAndClose={(e) => this.handleSaveModalOpen()}
            />
        )
    }

    coverageTerm() {
        return (
            <AppTextField
                title={
                    <div className="d-flex align-items-center">
                        Coverage Term
                        <Tooltip title={<div><b>Coverage Term</b> <div>Loan Term + Deferment Period</div></div>}>
                            <InfoIcon className="ml-1" />
                        </Tooltip>
                    </div>
                }
                type={'text'}
                disabled={true}
                value={this.state.coverageTerm}
                onChange={this.handleCoverageTerm}
                error={this.state.errorCoverageTermInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    initialSumCovered() {
        return (
            <AppTextField
                title={'Initial Sum Covered '}
                type={'text'}
                placeholder={'0.00'}
                prefix={'RM'}
                disabled={true}
                value={this.state.initialSumCovered}
                onChange={this.handleInitialSumCovered}
                error={this.state.errorInitialSumCoveredInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    contributionAmount() {
        return (
            <AppTextField
                title={'Total Single Contribution (Inclusive of fixed wakalah fee)'}
                type={'text'}
                placeholder={'0.00'}
                prefix={'RM'}
                disabled={true}
                value={this.state.contributionAmount}
                onChange={this.handleContributionAmount}
                error={this.state.errorContributionAmount}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    criticalIllnessProtectionAmount() {
        return (
            <AppTextField
                title={'Critical Illness Protection Amount'}
                type={'text'}
                placeholder={'0'}
                prefix={'RM'}
                disabled={true}
                value={this.state.criticalIllnessProtectionAmount}
                onChange={this.handleCriticalIllnessBenefitChange}
                error={this.state.errorCriticalIllnessProtectionAmountInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                    }}
                >
                    <>
                        <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        >
                            <div style={{ width: '60%' }}>
                                <AppSteps
                                    direction="horizontal"
                                    current={2}
                                    items={StepData}
                                />
                            </div>

                        </App_header>
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 50
                            }}
                        >
                            {this.state.loading && this.loadingContent()}
                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={'Step 3 - Takaful Details'}
                                    description={'Please fill in the details and ensure the information you provided is correct'}
                                    handleBack={() => this.getBackToFinancingDetails()}
                                />
                            </div>
                            <div className="w-100 form_container m-2" >
                                <div className="row m-0 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-1">
                                        {this.coverageTerm()}
                                    </div>

                                </div>
                                <div className="row m-0 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-1">
                                        {this.initialSumCovered()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        {this.contributionAmount()}
                                    </div>
                                </div>
                                <div className="row m-0 pt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-1">
                                        {this.criticalIllnessProtectionAmount()}
                                    </div>

                                </div>
                            </div>
                        </div>
                        {this.renderBottomBar()}
                        <AppModal
                            open={this.state.isSaveModalOpen}
                            handleModalClose={this.handleSaveModalClose}
                            width={'50%'}
                            title={'Do you want to stop?'}
                            subtitle={'If you stop without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={this.handleStopWithoutSaving}
                            handlePositivePress={this.handleSaveCurrentStep}
                            closable={false}
                        >
                        </AppModal>
                        <AppModal
                            open={this.state.isDiscardModalOpen}
                            handleModalClose={this.handleDiscardModalClose}
                            width={'50%'}
                            title={'Do you want to discard?'}
                            subtitle={'If you discard without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={this.handleStopWithoutSaving}
                            handlePositivePress={this.handleSaveCurrentStep}
                            closable={false}
                        />
                        <AppModal
                            open={this.state.editErrorModal}
                            // handleModalClose={() => this.setState({ editErrorModal: false })}
                            width={'50%'}
                            title={'Cannot be Edit/Update'}
                            subtitle={'This quotation cannot be update or edit'}
                            positiveButtonText={'Back'}
                            handlePositivePress={() =>
                                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
                            }
                            closable={false}
                        />
                        <AppModal
                            open={this.state.errorModal}
                            handleModalClose={() => this.setState({ errorModal: false })}
                            width={'50%'}
                            title={this.state.title}
                            subtitle={this.state.message}
                            positiveButtonText={'Close'}
                            handlePositivePress={() => this.setState({ errorModal: false })}
                            closable={false}
                        />
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(TakafulDetailsForm));
